<script lang="ts" setup>
import ChannelList from '@/components/channels/ChannelListIndex.vue'
import SidebarEventsList from '@/components/events/SidebarEventsList.vue'
import GroupList from '@/components/groups/GroupList.vue'
import LeaderboardRewardsList from '@/components/leaderboard/web/LeaderboardRewardsList.vue'
import { Theme } from '@/composition/themes'
import { useRoute } from 'vue-router'

const route = useRoute()
</script>
<template>
  <div
    class="no-scroll sticky top-0 flex h-[100vh] w-full text-communities-font-primary"
    :class="[
      Theme?.state?.windowGradient
        ? Theme.state.isSideBarBackgroundDark
          ? 'bg-gradient-to-b  from-communities-sidebar-background-gradient from-20% to-communities-sidebar-background'
          : 'bg-gradient-to-b from-communities-sidebar-background from-50% to-communities-sidebar-background-gradient'
        : 'bg-communities-sidebar-background',
      // Use the `isSameColor` variable to conditionally apply the border class
      Theme.state.isBackgroundSideBarColorSame
        ? 'border-b-0 border-l-0 border-t-0 border-solid border-communities-border'
        : '',
    ]"
  >
    <GroupList class="w-[58px]" />

    <div class="flex-1">
      <LeaderboardRewardsList
        v-if="route.name === 'leaderboard'"
        class="mt-[58px]"
      />
      <SidebarEventsList
        v-else-if="route.name === 'events'"
        class="mt-[58px]"
      />
      <ChannelList v-else class="mt-[58px]" />
    </div>
  </div>
</template>
<style scoped></style>
